import { AxiosResponse } from 'axios';
import i18n from 'config/i18n';
import { FormState } from 'react-hook-form';

import { getLocale } from 'utils/date';

import {
  AuxTranslationEntity,
  createAuxValueTranslation,
  editAuxValueTranslation
} from 'RestAPIs/AuxiliaryValues';

import { showSnackbar } from 'components/shared';

import { AuxFormValues } from '../AuxValuesForm';

const t = i18n.getFixedT(getLocale(), 'common');

const handleSaveTranslations = (
  auxValueId: number | undefined,
  formState: FormState<AuxFormValues>,
  translations: AuxTranslationEntity[]
) => {
  if (translations && translations.length > 0) {
    const requestsArray: Promise<AxiosResponse>[] = [];
    translations.forEach((translation) => {
      if (translation.auxValueTranslationId) {
        requestsArray.push(editAuxValueTranslation(translation));
      } else {
        requestsArray.push(
          createAuxValueTranslation({ ...translation, auxValueId: auxValueId })
        );
      }
    });

    return Promise.all(requestsArray).catch(() =>
      showSnackbar({
        message: t('somethingWentWrong'),
        severity: 'error'
      })
    );
  }

  return Promise.resolve();
};

export default handleSaveTranslations;
